// extracted by mini-css-extract-plugin
export default {"tablestyle":"tablestyle_tablestyle__WAILu"};